module.exports = __webpack_public_path__ + "static/img/column_img_9-2.da37c2bf.png";